import { DateTime } from 'luxon'

import AccountStore from '../Stores/Account'

export default function setAccountStore ({ user_id, code_client })
{
	AccountStore.update(function (store)
	{
		store.date = DateTime.now().toISO();
		store.status = 'set';
		store._id = user_id || '';
		store.code_client = code_client || '';

		window.localStorage.setItem('account@date', store.date);
		window.localStorage.setItem('account@status', store.status);
		window.localStorage.setItem('account@_id', store._id);
		window.localStorage.setItem('account@code_client', store.code_client);

		return store;
	});
}